define('_collections/SitesAsEditor',[
],
function(
) {
	return Backbone.Collection.extend({

		url : function() {
			var path =  "/_api/v0/site/" + Backstage.Model.Default.get('cookie_url') + "?fields=sites_as_editor";
			return path;
		},

		fetch : function(options) {
		
			if ( $("script[data-set='SitesAsEditor']").html() ) {
				this.set( $.parseJSON( $("script[data-set='SitesAsEditor']").html() ), options );
				$("script[data-set='SitesAsEditor']").remove();
			} else {
				return Backbone.Model.prototype.fetch.apply(this, arguments);
			}

		},

		/**
		 *	Overwrite the parse function and handle the "sites_as_editor" key
		 */
		parse : function (response) {
			return (response.sites_as_editor) ? response.sites_as_editor : response;
		}
	});
});

